if (!customElements.get("video-highlights-slider")) {
    class VideoHighlightsSlider extends HTMLElement {
        constructor() {
            super();
            this.sliderItem = this.querySelector('.swiper');
            this.init();
        }

        init() {
            // Basic configuration for continuous loop effect
            const swiperOptions = {
                slidesPerView: 1.8,
                spaceBetween: 16,
                loop: true,
                centeredSlides: true,
                // bgLazy: true,
                // speed: 5000,
                // autoplay: {
                //     delay: 0,
                //     disableOnInteraction: false,
                //     pauseOnMouseEnter: true
                // },
                breakpoints: {
                    750: {
                        slidesPerView: 3,
                        spaceBetween: 24,
                        centeredSlides: false,
                    },
                    1100: {
                        slidesPerView: 4,
                        spaceBetween: 24,
                        centeredSlides: false,
                    }
                },
                // Linear easing for smooth continuous effect
                // on: {
                //     init: function () {
                //         this.wrapperEl.style.transitionTimingFunction = 'linear';
                //     }
                // }
            };

            this.swiper = new Swiper(this.sliderItem, swiperOptions);
            this.initNestedSwipers();
        }

        initNestedSwipers() {
            const nestedSwipers = this.querySelectorAll('.nested-swiper');
            nestedSwipers.forEach(swiperEl => {
                new Swiper(swiperEl, {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    loop: true,
                    nested: true, // Critical for nested swipers
                    autoplay: {
                        delay: 2000,
                        disableOnInteraction: false,
                    },
                    pagination: {
                        el: swiperEl.querySelector('.swiper-pagination'),
                        clickable: true,
                    },
                    effect: 'fade', // Optional: nice effect for image transitions
                    fadeEffect: {
                        crossFade: true
                    }
                });
            });
        }
    }

    customElements.define("video-highlights-slider", VideoHighlightsSlider);
}
